import { assignAll, find, map } from 'lodash/fp';
import { Table } from '@ahmdigital/ui';

import { CoversProp, FeaturesProp } from '../shared/props';
import Cell from './cell';
import styles from './styles.module.sass';

type CompareCoverTableProps = {
  covers: CoversProp;
  features: FeaturesProp;
};

const CompareCoverTable = ({ covers, features }: CompareCoverTableProps) => {
  const columns = [
    {
      colProps: {
        dataVariant: [styles.descriptionData, styles.cell],
        df: 4,
        sm: 12,
        variant: [styles.descriptionHeader, styles.headingCell, styles.cell],
      },
      header: 'Cover',
      key: 'title',
    },
    ...map(
      ({ name, id }) => ({
        colProps: {
          dataVariant: styles.cell,
          df: 4,
          sm: 6,
          variant: [styles.cell, styles.headingCell],
        },
        header: name,
        key: id,
      }),
      covers,
    ),
  ];

  const data = map(({ id }) => {
    // @ts-expect-error - Automatic, Please fix when editing this file
    const { name } = find({ id }, features);
    const inclusions = map(({ features: coverFeatures, id: coverId }) => {
      // @ts-expect-error - Automatic, Please fix when editing this file
      const { inclusionState } = find({ id }, coverFeatures);

      return {
        [coverId]: <Cell inclusionType={inclusionState} />,
      };
    }, covers);

    return assignAll([
      {
        title: <strong>{name}</strong>,
      },
      ...inclusions,
    ]);
  }, features);

  return (
    <Table columns={columns} data={data} variant={['noHeaderBorder', 'compact', 'noBordersMobile', styles.table]} />
  );
};

export default CompareCoverTable;
